import { render, staticRenderFns } from "./DashboardClassificator.vue?vue&type=template&id=ab187360&scoped=true"
import script from "./DashboardClassificator.vue?vue&type=script&lang=js"
export * from "./DashboardClassificator.vue?vue&type=script&lang=js"
import style0 from "./DashboardClassificator.vue?vue&type=style&index=0&id=ab187360&prod&lang=scss&scoped=true"
import style1 from "./DashboardClassificator.vue?vue&type=style&index=1&id=ab187360&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab187360",
  null
  
)

export default component.exports